import React from 'react'
import { Box, Flex, Skeleton } from '@chakra-ui/core'
import styled from '@emotion/styled'

const StyledCard = styled(Box)`
  border-radius: 12px;
  background: rgba(240, 240, 245, 0.3);
  box-shadow: 0 0px 8px rgba(0, 0, 0, 0.06);
  padding: 16px;

  @media (min-width: 768px) {
    padding: 20px;
  }
`

const SkeletonCircle = styled(Skeleton)`
  border-radius: 50%;
`

export const RankingCardSkeleton: React.FC = () => {
  return (
    <StyledCard>
      {/* Avatar + Название + Имя менеджера */}
      <Flex alignItems="center" mb="16px" style={{ columnGap: '20px' }}>
        <SkeletonCircle width="50px" height="45px" />
        <Flex flexDir="column" w="100%" style={{ gap: '8px' }}>
          <Skeleton height="18px" w="65%" borderRadius="4px" />
          <Skeleton height="14px" w="45%" borderRadius="4px" />
        </Flex>
      </Flex>

      {/* Divider */}
      <Skeleton height="1px" mb="12px" borderRadius="0" />

      {/* Значение справа + Доп. информация слева */}
      <Flex justifyContent="space-between" alignItems="center" w="100%" mt="12px">
        <Flex flexDir="column" style={{ gap: '6px' }}>
          <Skeleton height="14px" w="80px" borderRadius="4px" />
        </Flex>
        <Skeleton height="22px" w="60px" borderRadius="4px" />
      </Flex>
    </StyledCard>
  )
}
